import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface LegalAccordionProps {
  variant?: 'light' | 'dark';
}
const PRIVACY_POLICY = `Calma en Casa respeta tu privacidad. Al usar este sitio y responder el test, aceptas lo siguiente:

• Datos recopilados: Las respuestas del test se procesan de forma anónima para generar tu resultado personalizado. No almacenamos información médica ni datos sensibles de menores.

• Uso de datos: Tu correo electrónico (si lo proporcionas al momento de la compra) se utiliza únicamente para enviarte el acceso al material digital y comunicaciones relacionadas con Calma en Casa.

• Terceros: No vendemos, compartimos ni cedemos tus datos personales a terceros con fines comerciales. El procesamiento del pago se realiza a través de Hotmart, una plataforma segura de pagos digitales.

• Cookies: Este sitio puede utilizar cookies técnicas para mejorar tu experiencia de navegación.

• Tus derechos: Puedes solicitar la eliminación de tus datos en cualquier momento escribiendo a nuestro correo de contacto.

• Menores: Este sitio está dirigido a padres y madres adultos. No recopilamos datos directamente de menores de edad.

Esta política puede actualizarse periódicamente. Te recomendamos revisarla de vez en cuando.`;
const TERMS_OF_USE = `Al acceder a este sitio web y utilizar el test de Calma en Casa, aceptas los siguientes términos:

• Naturaleza del contenido: Calma en Casa es un recurso educativo. El test y el plan de 21 días ofrecen orientación práctica para padres. No constituyen un diagnóstico médico, psicológico ni terapéutico.

• No sustituye atención profesional: Este contenido no reemplaza la evaluación ni el tratamiento de un profesional de la salud, psicología o educación. Si tu hijo necesita atención especializada, consulta con un profesional cualificado.

• Producto digital: Al realizar la compra a través de Hotmart, recibes acceso inmediato al material digital. Las condiciones de reembolso están sujetas a la política de Hotmart.

• Propiedad intelectual: Todo el contenido de Calma en Casa (textos, plantillas, audios, rutinas visuales) está protegido por derechos de autor. No está permitida su reproducción, distribución ni reventa sin autorización.

• Resultados: Los resultados del test son orientativos y se basan en las respuestas proporcionadas. No garantizamos resultados específicos en el comportamiento de tu hijo, ya que cada familia y cada niño es diferente.

• Responsabilidad: Calma en Casa no se hace responsable del uso que cada familia haga del material ni de los resultados individuales obtenidos.

• Modificaciones: Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos desde su publicación en este sitio.`;
const sections = [{
  title: 'Política de Privacidad',
  content: PRIVACY_POLICY
}, {
  title: 'Términos de Uso',
  content: TERMS_OF_USE
}];
export function LegalAccordion({
  variant = 'light'
}: LegalAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const isDark = variant === 'dark';
  return <div className="space-y-3 w-full" data-id="element-343">
      {sections.map((section, i) => <div key={i} className={`rounded-2xl overflow-hidden border ${isDark ? 'border-white/10 bg-white/5' : 'border-gray-200 bg-gray-50'}`} data-id="element-344">
          <button className={`w-full flex items-center justify-between px-5 py-4 text-left transition-colors ${isDark ? 'hover:bg-white/10 text-gray-300' : 'hover:bg-gray-100 text-gray-600'}`} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-345">
            <span className={`font-bold text-sm ${isDark ? 'text-gray-200' : 'text-gray-700'}`} data-id="element-346">
              {section.title}
            </span>
            <ChevronDown size={18} className={`shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''} ${isDark ? 'text-gray-400' : 'text-gray-400'}`} data-id="element-347" />
          </button>
          <AnimatePresence data-id="element-348">
            {openIndex === i && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="overflow-hidden" data-id="element-349">
                <div className={`px-5 pb-5 text-xs leading-relaxed whitespace-pre-line ${isDark ? 'text-gray-400 border-t border-white/10' : 'text-gray-500 border-t border-gray-200'} pt-4`} data-id="element-350">
                  {section.content}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}